<template>
  <div style="display: inline-block width: 100%; color: rgba(255, 255, 255, 0.7);">
  <div v-if="title"> {{ title }} </div>
  <v-menu absolute :position-x="x" :position-y="y" open-on-hover v-model="menu" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-text-field @mouseover="show" v-on="on" :style="style" :class="classes" :value="color" solo dense :background-color="color" hide-details type="text">
      </v-text-field>
    </template>
    <v-card>
      <v-color-picker v-model="color" canvas-height="200" width="200" hide-inputs flat/>
    </v-card>
  </v-menu>
  </div>
</template>

<script>
import { HexToHSVA } from 'vuetify/lib/util/colorUtils.js'

    export default {
        name: 'ColorPicker',
        methods: {
            show: function(e) {
                this.x = e.pageX;
                this.y = e.pageY;
            },
        },
        mounted() {
            this.color = this.value;
        },
        data: function() {
            return { color: '#FF0000FF',
                     menu: false,
                     mask: '!#XXXXXXXX',
                     classes: "color-picker white-text",
                     x: 0,
                     y: 0,
                   };
        },
        props: ['value', 'title'],
        watch: {
            value: function() {
                this.color = this.value;
            },
            color: function() {
                let hsva = HexToHSVA(this.color);
                if (hsva.v < 0.5 || hsva.s > 0.5) {
                    this.classes = "color-picker white-text";
                } else {
                    this.classes = "color-picker black-text";
                }

                this.$emit('input', this.color);
            },
        },
        computed: {
            style: function() {
                const { color } = this;
                return { backgroundColor: color,
                         color: color,
                       };
            },
        },
    }
</script>
<style>
.color-picker.v-text-field.v-text-field--solo .v-input__control input {
    outline: none;
    border: 0px;
    font-weight: bold;
    text-align: center;
    text-shadow: rgba(0, 0, 0, 0.7) 0px 1px 1px;
}

.color-picker.black-text input {
    color: rgb(0, 0, 0);
    text-shadow: rgba(255, 255, 255, 0.7) 0px 1px 1px;
}

.color-picker.white-text input {
    color: rgb(255, 255, 255);
    text-shadow: rgba(0, 0, 0, 0.7) 0px 1px 1px;
}
</style>
